(function(){
  // mobile nav toggle
  var toggle=document.querySelector('.nav-toggle');
  var nav=document.querySelector('.site-nav');
  if(toggle&&nav){
    toggle.addEventListener('click',function(){nav.classList.toggle('is-open');});
  }
  // scroll reveal
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items=document.querySelectorAll('.reveal');
  if(reduce||!('IntersectionObserver' in window)){
    items.forEach(function(el){el.classList.add('is-in');});
    return;
  }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}
    });
  },{threshold:0.12});
  items.forEach(function(el){io.observe(el);});
})();
